// extracted by mini-css-extract-plugin
export var container = "_fw-0";
export var dotAnimation = "_fw-2";
export var dotsLoading = "_fw-1";